import React, { useState, useRef,useEffect } from "react"

import "./Title.css"
import { Html } from "@react-three/drei"
import { useFrame } from '@react-three/fiber'

function Title({ position, rotation, titleITA, titleENG, handleModal, modalContentIT, modalContentEN, icon }) {

  const mesh = useRef()
  const startPosition = position[2]

  const [hidden, set] = useState()
  const [over, setOver] = useState(false)
  const modalContentObj = [
    {
      language: "IT",
      body: modalContentIT,
      type: "word",
      word: titleITA,
      icon,
    },
    {
      language: "EN",
      body: modalContentEN,
      type: "word",
      word: titleENG,
      icon,
    },
  ]

  useFrame((state, delta) => {
    if (mesh.current.position.z < -8 ) {
      mesh.current.position.z += 0.005
    } else {
      mesh.current.position.z = startPosition
    }
    
  }
  )


  return (
    <>
      <mesh ref={mesh} position={position} rotation={rotation}>
      
        <Html
          occlude
          onOcclude={set}
          style={{
            transition: "opacity 1s, transform 0.5s",
            opacity: hidden ? 0 : 1,
            visibility: hidden ? "hidden" : "visible",
            transform: `scale(${over ? 1.2 : 1})`,
          }}
          zIndexRange={[100, 0]}
          center
          transform
          distanceFactor={10}
        >
          <h1
            onMouseEnter={() => {
              setOver(true)
            }}
            onMouseLeave={() => {
              setOver(false)
            }}
            onClick={() => {
              handleModal(modalContentObj)
            }}
            className="Title__content"
          >
            {titleENG}
          </h1>
        </Html>
      </mesh>
    </>
  )
}

export default Title
